'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { blockReasons } from '@haaretz/s-consts';
import React from 'react';
const BlockReasonContext = /*#__PURE__*/ React.createContext(undefined);
const BlockReasonSetter = /*#__PURE__*/ React.createContext(undefined);
export function BlockReasonProvider({ children, value: defaultBlockReason }) {
    const [blockReason, setBlockReason] = React.useState(defaultBlockReason || null);
    const blockReasonSetter = React.useCallback((value)=>{
        if (typeof value === 'string' && value.trim() !== '') {
            setBlockReason(blockReasons.includes(value) ? value : null);
        } else {
            setBlockReason(null);
        }
    }, []);
    return /*#__PURE__*/ _jsx(BlockReasonContext, {
        value: blockReason,
        children: /*#__PURE__*/ _jsx(BlockReasonSetter, {
            value: blockReasonSetter,
            children: children
        })
    });
}
export default function useBlockReason() {
    const context = React.use(BlockReasonContext);
    if (context === undefined) {
        throw new Error('useBlockReason must be used within a BlockReasonProvider');
    }
    return context;
}
export function useSetBlockReason() {
    const context = React.use(BlockReasonSetter);
    if (context === undefined) {
        throw new Error('useSetBlockReason must be used within a BlockReasonProvider');
    }
    return context;
}
export function useBlockReasonAtom() {
    return [
        useBlockReason(),
        useSetBlockReason()
    ];
}

//# sourceMappingURL=blockReasonAtom.js.map